export const DEFAULT_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 10;

export const DEFAULT_PAGINATION_PARAM = {
  page: DEFAULT_PAGE,
  page_size: DEFAULT_PAGE_SIZE
};

type GetPageSizesProps = (totalItems: number) => number[];

/**
 * Use this function to get the `pageSizes` array to pass into the Lucidium Pagination component.
 * This will set the options (buttons) for "Rows Per Page" according to how many total items are in list and what the default page size is.
 * The last option for Rows Per Page will always be all items.
 */
export const getPageSizes: GetPageSizesProps = totalItems => {
  const defaultNumberOfPages = Math.floor(totalItems / DEFAULT_PAGE_SIZE);
  const isDefaultEqualTotal = DEFAULT_PAGE_SIZE === totalItems;
  const isDefault2xEqualTotal = DEFAULT_PAGE_SIZE * 2 === totalItems;

  // If less or equal than the default page size
  if (defaultNumberOfPages === 0 || isDefaultEqualTotal)
    return [DEFAULT_PAGE_SIZE];

  // If greater than the default page size
  if (defaultNumberOfPages === 1) return [DEFAULT_PAGE_SIZE, totalItems];

  // If two times greater but no more than 4x
  if (defaultNumberOfPages >= 2 && defaultNumberOfPages <= 4) {
    const sizes = [DEFAULT_PAGE_SIZE, DEFAULT_PAGE_SIZE * 2];

    if (!isDefault2xEqualTotal) sizes.push(totalItems);
    return sizes;
  } else {
    const sizes = [10, 20, 50];
    if (totalItems > 50 && totalItems < 100) sizes.push(totalItems);
    return sizes;
  }
};
